import { useState, useMemo } from 'react';
import { useOfficesInfo } from 'staticQueries/offices-info';
import { useWindowResize } from 'utils/hooks';
import { useFetchOfficesIds } from 'utils/officesMap';

export const useOffices = () => {
  const offices = useOfficesInfo();
  const { width } = useWindowResize();
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [coordinates, setCoordinates] = useState(null);
  const isSmallScreenVersion = width < 656;

  const { inViewRef, officesIds, loading } = useFetchOfficesIds();

  const closeOfficePopupHandler = () => {
    setSelectedOffice(null);
  };

  const officesList = useMemo(() => {
    const result = officesIds?.reduce((acc, locationItem) => {
      const office = offices.find(office => office.id === locationItem);
      office && acc.push(office);
      return acc;
    }, []);

    return result;
  }, [officesIds, loading, offices]);

  return {
    loading,
    officesList,
    isSmallScreenVersion,
    closeOfficePopupHandler,
    selectedOffice,
    setSelectedOffice,
    coordinates,
    setCoordinates,
    inViewRef,
  };
};
